import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DelegatesService {

  constructor(private readonly http: HttpClient) { }
  
  getDelegates(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.baseUrl}/users/delegates`);
    // return this.http.get<Delegate[]>('/assets/json/delegates.json');
  }
  getCandidates(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.baseUrl}/users/delegates/candidates`);
    // return this.http.get<Delegate[]>('/assets/json/candidates.json');
  }
  addDelegate(delegateId: string) {
    return this.http.put<any[]>(`${environment.baseUrl}/users/delegates/${delegateId}`, {});
  }
  removeDelegate(delegateId: string) {
    return this.http.delete<any[]>(`${environment.baseUrl}/users/delegates/${delegateId}`);
  }
}
